import { render } from "./myAfterSalesDetail.vue?vue&type=template&id=34c04eca&scoped=true"
import script from "./myAfterSalesDetail.vue?vue&type=script&lang=js"
export * from "./myAfterSalesDetail.vue?vue&type=script&lang=js"

import "./myAfterSalesDetail.vue?vue&type=style&index=0&id=34c04eca&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c04eca"]])

export default __exports__